import { render, staticRenderFns } from "./alarmDetails.vue?vue&type=template&id=d387fa1e"
import script from "./alarmDetails.vue?vue&type=script&lang=js"
export * from "./alarmDetails.vue?vue&type=script&lang=js"
import style0 from "./alarmDetails.vue?vue&type=style&index=0&id=d387fa1e&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports